export default function () {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20482)">
                <path
                    d="M21 15H7C5.89543 15 5 14.1046 5 13V9H23V13C23 14.1046 22.1046 15 21 15Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5 23H8.5C7.67157 23 7 22.3284 7 21.5C7 20.6716 7.67157 20 8.5 20H19.5C20.3284 20 21 20.6716 21 21.5C21 22.3284 20.3284 23 19.5 23Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.0845 4.97668L9.52824 5.71287C9.29283 6.02443 9.45385 6.47518 9.83338 6.56708V6.56708C10.2205 6.6608 10.378 7.12581 10.1275 7.43545L9.51687 8.19019"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    d="M14.0845 4.97668L13.5282 5.71287C13.2928 6.02443 13.4538 6.47518 13.8334 6.56708V6.56708C14.2205 6.6608 14.378 7.12581 14.1275 7.43545L13.5169 8.19019"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    d="M18.0845 4.97668L17.5282 5.71287C17.2928 6.02443 17.4538 6.47518 17.8334 6.56708V6.56708C18.2205 6.6608 18.378 7.12581 18.1275 7.43545L17.5169 8.19019"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    d="M21.7139 17H6.28614C5.58874 17 4.98334 17.4807 4.82521 18.1599L3.42839 24.1599C3.2094 25.1006 3.9235 26 4.88932 26H23.1107C24.0765 26 24.7906 25.1006 24.5716 24.1599L23.1748 18.1599C23.0167 17.4807 22.4113 17 21.7139 17Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M28 12H23V9H29V11C29 11.5523 28.5523 12 28 12Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20482">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
